import { ContextMenuFC, ContextMenuWrapper } from 'tncet-common';
import './index.less';
import { ReactComponent as LogoSvg } from './icons/logo.svg';
import { ReactComponent as DownArrowSvg } from './icons/down-arrow.svg';
import { ReactComponent as UpArrowSvg } from './icons/up-arrow.svg';
import { ReactComponent as SwitchSvg } from './icons/switch.svg';
import { ReactComponent as PicSvg } from './icons/pic.svg';
import { ReactComponent as AddSvg } from './icons/add.svg';
import { ReactComponent as BigSvg } from './icons/big.svg';
import { ReactComponent as DeviceSvg } from './icons/device.svg';
import { ReactComponent as DeviceActiveSvg } from './icons/device-active.svg';
import { ReactComponent as SmallSvg } from './icons/small.svg';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import CreateProjectModal from '../create-project-modal';
import classNames from 'classnames';
import { Project } from '@/global/interface/project-manage/project';
import { getProjects } from '@/api/project-manage/project';
import localStore from '@/global/store/local-store';
import { LogoutOutlined } from '@ant-design/icons';


interface IProps {
    showDevice?: boolean
    onChangeShowDevice?: (show: boolean) => void
}

export default function SystemManageArea(props: IProps) {

    const { showDevice, onChangeShowDevice } = props;

    const navigate = useNavigate();
    const location = useLocation();
    const { projectId } = useParams();
    const [project, setProject] = useState<Project>(null);
    const [projects, setProjects] = useState<Project[]>([]);
    const [showProject, setShowProject] = useState<boolean>(false);
    const [showExpand, setShowExpand] = useState<boolean>(false);
    const [currentPanel, setCurrentPanel] = useState<'bim' | 'screen'>();
    const [showModal, setShowModal] = useState<boolean>(false);
    const [fullScreen, setFullScreen] = useState<boolean>(true);
    const [cmOpen, setCmOpen] = useState<boolean>(false); // 是否展开菜单
    const [top, setTop] = useState<number>(); // 菜单top
    const [left, setLeft] = useState<number>(); // 菜单left
    const userRef = useRef(null);

    // 监听路由
    useEffect(() => {
        setShowProject(!location.pathname.includes('/desktop'));
        if (location.pathname.includes('/bim')) {
            setCurrentPanel('bim');
        }
        if (location.pathname.includes('/screen')) {
            setCurrentPanel('screen');
        }
    }, [location])

    // 初始化数据
    useEffect(() => {
        generateData();
    }, [])

    // 获取数据
    const generateData = () => {
        getProjects({ userId: localStore?.userId }).then(res => {
            let data: Project[] = res.data || [];
            setProjects(data);
        })
    }

    // 监听项目变化
    useEffect(() => {
        if (!projectId) {
            setProject(null);
            return;
        }
        let curProj: Project = projects?.find(item => item.id === +projectId);
        setProject(curProj);
    }, [projectId, projects])

    // 切换端
    const toggleLayout = () => {
        if (currentPanel === 'bim') {
            setFullScreen(true);
            onAllScreen();
            navigate(`/screen/project/${projectId}/`)
        } else if (currentPanel === 'screen') {
            setFullScreen(false);
            cancelAllScreen();
            navigate(`/bim/project/${projectId}/`)
        }
    }

    // 切换项目
    const projectClick = (item: Project) => {
        if (currentPanel === 'bim') {
            setFullScreen(true);
            // onAllScreen();
            cancelAllScreen();
            navigate(`/bim/project/${item.id}/draw/draw-main/`)
        } else if (currentPanel === 'screen') {
            setFullScreen(false);
            // cancelAllScreen();
            onAllScreen();
            navigate(`/screen/project/${item.id}/`)
        }
        setShowExpand(false);
    }

    // 切换全屏
    const toggleScreen = () => {
        if (currentPanel !== 'screen') return;
        setFullScreen(pre => {
            if (pre) {
                cancelAllScreen();
            } else {
                onAllScreen();
            }
            return !pre;
        })
    }

    // 切换为全屏
    const onAllScreen = () => {
        let elem = document.documentElement;
        if (!document.fullscreenElement && elem?.requestFullscreen) {
            elem?.requestFullscreen();
        }
    }

    // 取消全屏
    const cancelAllScreen = () => {
        if (document.fullscreenElement && document?.exitFullscreen) {
            document?.exitFullscreen();
        }
    }

    const logOut = () => {
        localStore.clear();
        navigate("/login");
        cancelAllScreen();
    }

    return (
        <div className="system-manage-container">
            <div className='logo' onClick={() => {
                navigate(`/desktop/project-list`);
                cancelAllScreen();
            }}><LogoSvg /></div>
            {showProject && <>
                <ContextMenuWrapper
                    visible={showExpand}
                    closable={true}
                    onVisibleChange={(visible: boolean) => {
                        setShowExpand(visible);
                    }}
                    width={243}
                    container={
                        <div className='project-panel'>
                            <div className='project-name'>{project?.name || ''}</div>
                            <div className='project-arrow'>
                                {showExpand && <UpArrowSvg />}
                                {!showExpand && <DownArrowSvg />}
                            </div>
                        </div>
                    }
                    wrapperClassname='project-dropdown-panel'
                >
                    <div className='project-dropdown-scroll-area'>
                        {projects?.map(item => (
                            <div
                                className={classNames({
                                    'project-dropdown-item': true,
                                    'project-dropdown-item-active': item?.id === +projectId,
                                })}
                                key={item.id}
                                onClick={() => projectClick(item)}
                            >{item?.name || ''}</div>
                        ))}
                    </div>
                </ContextMenuWrapper>
                <div className='add-panel' onClick={() => setShowModal(true)}><AddSvg /></div>
            </>}
            <div className='right-group'>
                {currentPanel === 'screen' && <div className='full-panel' onClick={() => {
                    onChangeShowDevice(!showDevice);
                }}>
                    {!showDevice && <div className='full-icon'><DeviceSvg /></div>}
                    {showDevice && <div className='full-icon'><DeviceActiveSvg /></div>}
                </div>}
                {currentPanel === 'screen' && <div className='full-panel' onClick={toggleScreen}>
                    {!fullScreen && <div className='full-icon'><BigSvg /></div>}
                    {fullScreen && <div className='full-icon'><SmallSvg /></div>}
                </div>}
                {showProject && <div className='switch-panel' onClick={toggleLayout}>
                    <div className='switch-icon'><SwitchSvg /></div>
                </div>}
                <div className='user-panel' ref={userRef} onClick={e => {
                    e.stopPropagation();
                    e.preventDefault();
                    setCmOpen(true);
                    const rect = userRef.current.getBoundingClientRect();
                    setCmOpen(true);
                    setLeft(rect.left + 2);
                    setTop(rect.top + 26);
                }}>
                    <PicSvg />
                    <div>{localStore?.name || ''}</div>
                </div>
            </div>


            {showModal && <CreateProjectModal
                showModal={showModal}
                setShowModal={setShowModal}
                onSuccess={() => {
                    generateData();
                    setShowModal(false);
                }}
            />}

            <ContextMenuFC
                visible={cmOpen}
                top={top}
                left={left}
                width={96}
                wrapperClassname='device-list-right-menu'
                onCancel={() => { setCmOpen(false); }}
            >
                <div className="menu-item" onClick={logOut}><LogoutOutlined /> 退出登录</div>
            </ContextMenuFC>
        </div>
    )
}